import { proxy } from "valtio";

export const meshParts = [
  "top",
  "bot",
  "other",
  "topRoughness",
  "botRoughness",
  "topMetallic",
  "botMetallic",
  "otherMetallic",
  "topNormal",
  "botNormal",
  "otherNormal",
];

export const infopoints = [
  {
    position: [-0.1, -0.01, 0],
    cameraPosition: [0, 0.3, 0.2],
    description: (<><h3>Scafo trasparente per ammirare i fondali</h3><p>Pescaggio: 0.68 m</p></>),
  },
  {
    position: [0.05, 0.15, 0],
    cameraPosition: [0.2, 0.15, 0.1],
    description: (<><h3>Controlli ergonomici</h3></>)
  },
  {
    position: [0.31, -0.31, 0.18],
    cameraPosition: [0, -0.3, 0.18],
    description: (<><h3>Motori elettrici</h3><p>Potenza: 2x10kw</p><p>Velocità massima: 24 nodi</p></>)
  },
  {
    position: [-0.18, 0.02, -0.5],
    cameraPosition: [0, -0.3, 0.18],
    description: (<><h3>Foil per planare ad alta velocità</h3><p>Velocità di decollo: 8 nodi</p></>)
  },
  {
    position: [0.4, -0.1, 0.16],
    cameraPosition: [0, 0.3, 0],
    description: (<><h3>Fibra di carbonio</h3><p>Larghezza: 2.58 m</p><p>Lunghezza: 2.46 m</p></>)
  },
]

export const materialsAlaM = [
  {
    preview: "#4348AB",
    texture: {
      top: "01_Drago/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "01_Drago/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "01_Drago/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "01_Drago/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "01_Drago/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "01_Drago/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "01_Drago/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "01_Drago/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "01_Drago/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "01_Drago/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "01_Drago/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "01_Drago/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
  {
    preview: "#80C670",
    texture: {
      top: "02_Verde/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "02_Verde/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "02_Verde/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "02_Verde/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "02_Verde/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "02_Verde/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "02_Verde/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "02_Verde/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "02_Verde/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "02_Verde/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "02_Verde/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "02_Verde/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
  {
    preview: "#F3BF6E",
    texture: {
      top: "03_Fiamme/FLYER_definitivo_SOPRA_BaseColor.png",
      bot: "03_Fiamme/FLYER_definitivo_SOTTO_BaseColor.png",
      other: "03_Fiamme/FLYER_definitivo_ALTRO_BaseColor.png",
      topRoughness: "03_Fiamme/FLYER_definitivo_SOPRA_Roughness.png",
      botRoughness: "03_Fiamme/FLYER_definitivo_SOTTO_Roughness.png",
      otherRoughness: "03_Fiamme/FLYER_definitivo_ALTRO_Roughness.png",
      topMetallic: "03_Fiamme/FLYER_definitivo_SOPRA_Metallic.png",
      botMetallic: "03_Fiamme/FLYER_definitivo_SOTTO_Metallic.png",
      otherMetallic: "03_Fiamme/FLYER_definitivo_ALTRO_Metallic.png",
      topNormal: "03_Fiamme/FLYER_definitivo_SOPRA_Normal.png",
      botNormal: "03_Fiamme/FLYER_definitivo_SOTTO_Normal.png",
      otherNormal: "03_Fiamme/FLYER_definitivo_ALTRO_Normal.png",
    },
  },
  {
    preview: "#E34F65",
    texture: {
      top: "04_Carbon/FLYER.definitivo_SOPRA_BaseColor.png",
      bot: "04_Carbon/FLYER.definitivo_SOTTO_BaseColor.png",
      other: "04_Carbon/FLYER.definitivo_ALTRO_BaseColor.png",
      topRoughness: "04_Carbon/FLYER.definitivo_SOPRA_Roughness.png",
      botRoughness: "04_Carbon/FLYER.definitivo_SOTTO_Roughness.png",
      otherRoughness: "04_Carbon/FLYER.definitivo_ALTRO_Roughness.png",
      topMetallic: "04_Carbon/FLYER.definitivo_SOPRA_Metallic.png",
      botMetallic: "04_Carbon/FLYER.definitivo_SOTTO_Metallic.png",
      otherMetallic: "04_Carbon/FLYER.definitivo_ALTRO_Metallic.png",
      topNormal: "04_Carbon/FLYER.definitivo_SOPRA_Normal.png",
      botNormal: "04_Carbon/FLYER.definitivo_SOTTO_Normal.png",
      otherNormal: "04_Carbon/FLYER.definitivo_ALTRO_Normal.png",
    },
  },
  {
    preview: "#B77FC5",
    texture: {
      top: "05_Octo/FLYER.definitivo_SOPRA_BaseColor.png",
      bot: "05_Octo/FLYER.definitivo_SOTTO_BaseColor.png",
      other: "05_Octo/FLYER.definitivo_ALTRO_BaseColor.png",
      topRoughness: "05_Octo/FLYER.definitivo_SOPRA_Roughness.png",
      botRoughness: "05_Octo/FLYER.definitivo_SOTTO_Roughness.png",
      otherRoughness: "05_Octo/FLYER.definitivo_ALTRO_Roughness.png",
      topMetallic: "05_Octo/FLYER.definitivo_SOPRA_Metallic.png",
      botMetallic: "05_Octo/FLYER.definitivo_SOTTO_Metallic.png",
      otherMetallic: "05_Octo/FLYER.definitivo_ALTRO_Metallic.png",
      topNormal: "05_Octo/FLYER.definitivo_SOPRA_Normal.png",
      botNormal: "05_Octo/FLYER.definitivo_SOTTO_Normal.png",
      otherNormal: "05_Octo/FLYER.definitivo_ALTRO_Normal.png",
    },
  },
];

export const state = proxy({
  focusDetail: false,
  beforeExitFocus: false,
  infopoint: infopoints[0],
  color: materialsAlaM[0].preview,
  texture: materialsAlaM[0].texture,
  scrollY: 0,
  showVideo: false
});
